'use client';

/**
 * Theme Component Utilities - CLIENT ONLY
 * Helper functions for loading theme-specific UI components on the client
 * DO NOT use for page components - those are handled by the route registry
 */
import { ComponentType } from 'react';

import { logger } from '@/lib/logger.client';

export async function getThemeUIComponent<T = any>(componentName: string, themeId: string = 'cray'): Promise<ComponentType<T> | null> {
  try {
    const componentPath = `@/themes/${themeId}/ui/${componentName}`;
    const module = await import(componentPath);
    logger.debug(`Loaded UI component "${componentName}" from theme "${themeId}"`);
    return module.default || module[componentName] || null;
  } catch (error) {
    //console.warn(`Theme UI component "${componentName}" not found in theme "${themeId}":`, error);
    return null;
  }
}

/**
 * Client-side dynamic component loader for UI components only
 */
export function createThemeComponentLoader(componentName: string, themeId: string = 'cray') {
  return async () => {
    const component = await getThemeUIComponent(componentName, themeId);
    if (!component) {
      throw new Error(`UI Component "${componentName}" not found in theme "${themeId}"`);
    }
    return { default: component };
  };
}
